import { useEffect } from 'react';

interface AdBannerProps {
  adSlot: string; // Your AdSense ad slot ID
  style?: React.CSSProperties;
}

export const AdBanner: React.FC<AdBannerProps> = ({ adSlot, style }) => {
  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('Adsense push error', e);
    }
  }, []);

  return (
    <div />
    // <ins
    //   className="adsbygoogle"
    //   style={{ display: 'block', width: '100%', height: 90, ...style }}
    //   data-ad-client="ca-pub-6288473966257477"
    //   data-ad-slot={adSlot}
    //   data-ad-format="auto"
    //   data-full-width-responsive="true"
    // />
  );
};
